import { render } from "./sectionHero.vue?vue&type=template&id=0687a652&scoped=true"
import script from "./sectionHero.vue?vue&type=script&lang=js"
export * from "./sectionHero.vue?vue&type=script&lang=js"

import "./sectionHero.vue?vue&type=style&index=0&id=0687a652&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0687a652"]])

export default __exports__